import * as React from 'react';
import { useState } from 'react';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Header from './DashboardHeader';
import MainGrid from './MainGrid';
import MainMap from './MainMap';
import SideMenu from './SideMenu';

// Import additional components based on selections
import CashOffer from './CashOffer';
import Financing from './Financing';
import CreateListing from './CreateListing';
import BuyListing from './BuyListing';
import Renovations from './Renovations';
import Stage from './Stage';
import Photos from './Photos';
import BoostMarketing from './BoostMarketing';
import GetHelp from './GetHelp';
import Admin from './Admin';
import About from './About';
import Feedback from './Feedback';
import FollowUs from './FollowUs';

export default function Dashboard() {
  const [selectedMenu, setSelectedMenu] = useState('Home'); // Default to Home
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);


  // Function to determine which component to render
  const renderContent = () => {
    switch (selectedMenu) {
      case 'Map':
        return <MainMap sx={{ width: '100%' }} />;
      case 'Cash Offer':
        return <CashOffer sx={{ width: '100%' }} />;
      case 'Financing':
        return <Financing sx={{ width: '100%' }} />;
      case 'Create Listing':
        return <CreateListing sx={{ width: '100%' }} />;
      case 'Buy Listing':
        return <BuyListing sx={{ width: '100%' }} />;
      case 'Renovations':
        return <Renovations sx={{ width: '100%' }} />;
      case 'Stage':
        return <Stage sx={{ width: '100%' }} />;
      case 'Photos':
        return <Photos sx={{ width: '100%' }} />;
      case 'Boost Marketing':
        return <BoostMarketing sx={{ width: '100%' }} />;
      case 'Get Help':
        return <GetHelp sx={{ width: '100%' }} />;
      case 'Admin':
        return <Admin sx={{ width: '100%' }} />;
      case 'About':
        return <About sx={{ width: '100%' }} />;
      case 'Feedback':
        return <Feedback sx={{ width: '100%' }} />;
      case 'Follow Us':
        return <FollowUs sx={{ width: '100%' }} />;
      default:
        return <MainGrid setSelectedMenu={setSelectedMenu} sx={{ width: '100%' }} />; // Default view
    }
  };

  return (
    <Box sx={{ xs: 'none', md: 'block', display: 'flex' }}>
      <SideMenu onSelect={setSelectedMenu} />
      <Box
        component="main"
        sx={(theme) => ({
          flexGrow: 1,
          backgroundColor: theme.vars
            ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
            : alpha(theme.palette.background.default, 1),
          overflow: 'auto',
        })}
      >
        <Stack
          spacing={2}
          sx={{
            alignItems: 'center',
            mx: 3,
            pb: 5,
            mt: { xs: 8, md: 0 },
          }}
        >
          <Header />
          {renderContent()}
        </Stack>
      </Box>
    </Box>
  );
}


